var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.getSubscription && _vm.getPlans && _vm.getQuotas
    ? _c(
        "div",
        [
          _c(
            "v-list-item",
            {
              staticClass: "px-3",
              on: {
                click: function ($event) {
                  return _vm.$router.push({ name: "subscriptions" })
                },
              },
            },
            [
              _c(
                "v-list-item-content",
                { staticClass: "pb-0" },
                [
                  _c("v-list-item-title", { staticClass: "mb-0" }, [
                    _vm._v(" Plan "),
                  ]),
                  _vm._v(" "),
                  _c("v-list-item-subtitle", { staticClass: "pb-1 mt-0" }, [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.getPlans[_vm.getSubscription.type].name) +
                        "\n      "
                    ),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              !_vm.show && _vm.getSubscription.type !== "escala"
                ? _c(
                    "v-list-item-action",
                    { staticClass: "mt-3" },
                    [
                      _c(
                        "v-btn",
                        {
                          staticClass: "black--text",
                          attrs: {
                            "x-small": "",
                            rounded: "",
                            color: "accent",
                          },
                          on: {
                            click: function ($event) {
                              $event.stopPropagation()
                              _vm.dialogModalPlans = true
                            },
                          },
                        },
                        [_vm._v("\n        Actualizar plan\n      ")]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-list-item",
            {
              staticClass: "px-3",
              style: { "min-height": "20px" },
              on: {
                click: function ($event) {
                  return _vm.$router.push({ name: "subscriptions" })
                },
              },
            },
            [
              _c(
                "v-list-item-content",
                { staticClass: "py-0" },
                [
                  _c("v-progress-linear", {
                    style: { "max-height": "10px" },
                    attrs: {
                      color:
                        _vm.getPercentage >= 90 ? "red" : "accent accent-4",
                    },
                    model: {
                      value: _vm.getPercentage,
                      callback: function ($$v) {
                        _vm.getPercentage = $$v
                      },
                      expression: "getPercentage",
                    },
                  }),
                  _vm._v(" "),
                  !_vm.show
                    ? _c(
                        "div",
                        { staticClass: "d-flex justify-space-between" },
                        [
                          _c(
                            "span",
                            { staticClass: "text-caption text-secondary" },
                            [_vm._v("0")]
                          ),
                          _vm._v(" "),
                          _c("span", { staticClass: "text-caption" }, [
                            _vm._v(
                              _vm._s(_vm.getQuotas.orders_amount_max) +
                                " " +
                                _vm._s(_vm.getSubscription.currency.code)
                            ),
                          ]),
                        ]
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _vm.dialogModalPlans
            ? _c("ModalPlans", {
                attrs: { "open-dialog": _vm.dialogModalPlans },
                on: {
                  "update:openDialog": function ($event) {
                    _vm.dialogModalPlans = $event
                  },
                  "update:open-dialog": function ($event) {
                    _vm.dialogModalPlans = $event
                  },
                },
              })
            : _vm._e(),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }